import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { preprocessTextAsyncAutocompleteField } from "@/features/FormCard/utils";
import { z } from "zod";

//
// Zod schema
//
export const filterViewSchema = z.object({
  name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  content_url_contains: z.string().nullable().optional(),
  workbook_id_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
});

export type FilterViewSchema = z.infer<typeof filterViewSchema>;

//
// Field definitions
//
export const fields: Field[] = [
  {
    name: "name_contains",
    label: "Name",
    type: "asyncAutocomplete",
    base_url: "tableau-quantilia/views",
    column_name: "name",
  },
  {
    name: "content_url_contains",
    label: "Content URL",
    type: "input",
  },
  {
    name: "workbook_id_contains",
    label: "Workbook",
    type: "asyncAutocomplete",
    base_url: "tableau-quantilia/workbooks",
    column_name: "name",
  },
];

export const client = "qtl - tableau";

export function FilterView() {
  return (
    <FilterTable
      client={client}
      schema={filterViewSchema}
      tableName="views"
      customBuildPath={() => `${client}/views`}
      fields={fields}
    />
  );
}
